import React, { useState, useEffect } from 'react'
import axios from 'axios'

import './NovoAnexo.css'
import brasao from '../../assets/brasilNav.png'

const NovoAnexo = () => {
    const id = window.location.pathname.slice(17)
    const [processo, setProcesso] = useState({ dataCriacao: '' })
    const [dados, setDados] = useState({
        idPed: id, user: localStorage.nomeE, tipoAnexo: '', dataCriacao: new Date().toLocaleString()
    })

    useEffect(() => {
        const url = `/api/ped/getPed/${id}`
        axios(url)
            .then(res => {
                setProcesso(res.data)
            })
            .then()
            .catch(error => {
                alert(error.response.data)
            })
    }, [])

    const updateField = (e) => {
        const { name, value } = e.target
        if (name === "file") {
            let file = e.target.files[0]
            setDados(prevState => ({
                ...prevState,
                [name]: file
            }))
        } else {
            setDados(prevState => ({
                ...prevState,
                [name]: value
            }))
        }
    }

    const save = (e) => {
        const url = `/api/anexos/postsEtica`
        const formData = new FormData()
        formData.append("file", dados.file)
        formData.append("idPed", id)
        formData.append("user", dados.user)
        formData.append("tipoAnexo", dados.tipoAnexo)
        formData.append("dataCriacao", dados.dataCriacao)
        if (dados.documento) {
            formData.append("documento", dados.documento)
        }
        axios.post(url, formData)
            .then(res => {
                alert(res.data)
                window.location = `/etica/documentosPed/${id}`
            })
            .then()
            .catch(error => {
                alert(error.response.data)
            })
    }

    return (
        <React.Fragment>
            <div className="capaPedCaixaBranca">
                <img src={brasao} alt="Brasil" className='brasaoPed' />
                <div className='conselho'>CONSELHO REGIONAL DE FISIOTERAPIA E TERAPIA OCUPACIONAL DA 1ª REGIÃO</div>
                <div className="capaPedCaixaVerde">PROCESSO ÉTICO DISCIPLINAR</div>
                <div className="capaPedCaixaVerdeNumero">PED Nº {processo.numeroPed}</div>
                <div className="capaPedCaixaVerdeRepresentante">
                    <span className="capaPedRepresentante">Representante</span>
                    <div className="capaPedElement">{processo.representante}</div>
                    <div className="capaPedElement">{processo.numeroPaf}</div>
                </div>
                <div className="capaPedCaixaVerdeRepresentante">
                    <span className="capaPedRepresentante">Representado</span>
                    <div className="capaPedElement">{processo.representado}</div>
                    <div className="capaPedElement">{processo.numeroCrefito}</div>
                </div>
                <div className="capaPedCaixaVerdeNovoAnexo">
                    <div className="relatorRevisorMeio">
                        <span className="spanRelatorRevisor">Tipo do Anexo</span>
                        <select name="tipoAnexo" className="relatorRevisor"
                            onChange={e => updateField(e)} >
                            <option value=""></option>
                            <option value="Citação">Citação</option>
                            <option value="Despacho do Presidente">Despacho do Presidente</option>
                            <option value="Intimação">Intimação</option>
                            <option value="Termo Descritivo">Termo Descritivo</option>
                            <option value="Voto do Relator">Voto do Relator</option>
                            <option value="Despacho do Instrutor">Despacho do Instrutor</option>
                            <option value="Relatório">Relatório</option>
                            <option value="Revisão">Revisão</option>
                            <option value="Ofício Defensor Dativo">Ofício Defensor Dativo</option>
                            <option value="Despacho Defensor Dativo">Despacho Defensor Dativo</option>
                            <option value="Julgamento">Julgamento</option>
                            <option value="Acordão">Acordão</option>
                            <option value="Arquivo">Arquivo</option>
                            <option value="Outro">Outro</option>
                        </select>
                    </div>
                    <div className="overFlow">
                        <div className="relatorRevisorMeio">
                            <span className="spanRelatorRevisor">Arquivo</span>
                            <input type="file" className="fileAnexo"
                                name="file"
                                onChange={e => updateField(e)} />
                        </div>
                    </div>
                    {Documento()}
                </div>
            </div>
            <button className="botaoNPed" onClick={e => save(e)}>ENVIAR</button>
        </React.Fragment>
    )

    function Documento() {
        if (dados.tipoAnexo === "Outro") {
            return (
                <div className="relatorRevisorMeio">
                    <span className="spanRelatorRevisor">Documento</span>
                    <input type="text" className="relatorRevisor"
                        name="documento"
                        onChange={e => updateField(e)} />
                </div>
            )
        }
    }
}

export default NovoAnexo